import { useEffect, useState } from "react";
import { FaRegFrown, FaRegMeh, FaRegSmile } from "react-icons/fa";
import { FiMinusCircle } from "react-icons/fi";
import { RiChatNewLine } from "react-icons/ri";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL_PAYMENT } from "../../../utilities/url";
import CryptoJS from "crypto-js";
import storage from "../../../services/storage";
import { format_number } from "../../../utilities/ext-function";
import authService from "../../../services/auth.service";

export default function ChatbotChart() {
  const location = useLocation();
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const usr = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [dataChatbotGraf, setDataChatbotGraf] = useState([]);
  const [dataChatbotTop, setDataChatbotTop] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentYear = new Date().getFullYear();
  const lastThreeYears = Array.from({ length: 3 }, (_, i) => currentYear - i);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const handleChangeYear = (e) => {
    setSelectedYear(e.target.value);
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Get List Broddcast
    getDataChatbotGraf();
    getDataChatbotTop();
  }, [location.key, selectedYear]);

  const getDataChatbotGraf = () => {
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/activity", {
        params: {
          year: selectedYear,
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setLoading(false);
          setDataChatbotGraf(response.data.data);
        } else {
          setLoading(false);
          setDataChatbotGraf([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const getDataChatbotTop = () => {
    axios
      .get(API_URL_PAYMENT + "dashboard/osa/toposa", {
        params: {
          year: selectedYear,
        },
        headers: {
          "X-User-ID": usr.idt_user,
          "X-Workspace-ID": workspace.idt_user_workspace,
        },
      })
      .then((response) => {
        if (response.data.errorcode === "0000") {
          setLoading(false);
          setDataChatbotTop(response.data.data);
        } else {
          setLoading(false);
          setDataChatbotTop([]);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const data2 = [
    { name: "Positif", value: 40 },
    { name: "Netral", value: 30 },
    { name: "Negatif", value: 20 },
    { name: "Unsubs", value: 10 },
  ];

  const colors = ["#00c49f", "#fb8500", "#fc003b", "#0088fe", "#aaa"];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="row">
      <div className={windowWidth >= 1600 ? "col-12" : "col-12"}>
        <div className="card rounded-4 shadow-lg">
          <div className="card-header rounded-4 header-chart">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="card-title mb-0">Chatbot Interaction</h5>
                {/* <p className="text-dark mb-0">
                  Total 15.000 Chat Interaction - 10.000 Contact
                </p> */}
              </div>
              <div className="d-flex align-items-center">
                <span className="me-2" style={{ width: "100px" }}>
                  Filter Periode:
                </span>
                <select
                  className="form-select me-2"
                  style={{ width: "100px" }}
                  value={selectedYear} // Menghubungkan state ke dropdown
                  onChange={handleChangeYear} // Menjalankan fungsi saat ada perubahan
                >
                  {lastThreeYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                {/* <select
                  className="form-select"
                  style={{ width: "150px" }}
                  aria-label="Filter Periode 2"
                >
                  <option value="">Semua</option>
                  <option value="periode1">Januari</option>
                  <option value="periode2">Februari</option>
                </select> */}
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="card border-soft-grey rounded-4">
              <div className="card-body">
                <div className="row">
                  {/* Bagian untuk ChatbotChart dan list di satu baris */}
                  <div className="col-lg-7 d-lg-flex">
                    {/* ChatbotChart di sebelah kiri */}
                    <div className="col-lg-10">
                      <h5>Trend Chatbot</h5>
                      <div className="p-1">
                        {dataChatbotGraf.length > 0 && (
                          <ResponsiveContainer
                            width="100%"
                            height={300}
                            className="recharts-custom-container"
                            style={{
                              marginLeft: "-15px",
                            }}
                          >
                            <LineChart data={dataChatbotGraf}>
                              {/* <CartesianGrid strokeDasharray="3 3" /> */}
                              <XAxis dataKey="month" />
                              <YAxis />
                              <Tooltip contentStyle={{ color: "black" }} />
                              {/* <Legend /> */}
                              <Line
                                type="monotone"
                                dataKey="message_count"
                                name="Message"
                                stroke="#00c49f"
                                activeDot={{ r: 4 }}
                              />
                              <Line
                                type="monotone"
                                dataKey="session_count"
                                name="Session"
                                stroke="#0088fe"
                                activeDot={{ r: 4 }}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                        )}
                      </div>
                    </div>
                    {/* List Sukses, Invalid, Gagal di sebelah kanan dengan responsive height */}
                    <div className="col-lg-2 d-flex flex-column justify-content-between">
                      <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100">
                        <div className="me-2">
                          <div
                            className="mb-1"
                            style={{
                              width: "18px",
                              height: "18px",
                              backgroundColor: "#00c49f",
                              borderRadius: "50%",
                            }}
                          ></div>
                        </div>
                        <div>
                          <h5 className="mb-1">Message</h5>
                          <p className="text-dark fs-11 mb-0">
                            {format_number(
                              dataChatbotGraf.reduce(
                                (sum, item) => sum + item.message_count,
                                0
                              )
                            )}{" "}
                            chat
                          </p>
                          <p className="text-dark fs-11 mb-0">interaction</p>
                        </div>
                        {/* </div> */}
                      </div>
                      <div className="border rounded-3 border-soft-grey p-2 d-flex d-flex flex-column justify-content-center h-100">
                        <div className="me-2">
                          <div
                            className="mb-1"
                            style={{
                              width: "18px",
                              height: "18px",
                              backgroundColor: "#0088fe",
                              borderRadius: "50%",
                            }}
                          ></div>
                        </div>
                        <div className="d-flex flex-column">
                          <h5 className="mb-1">Session</h5>
                          <p className="text-dark fs-11 mb-0">
                            {format_number(
                              dataChatbotGraf.reduce(
                                (sum, item) => sum + item.session_count,
                                0
                              )
                            )}{" "}
                            contact
                          </p>
                          <p className="text-dark fs-11 mb-0">interaction</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      windowWidth >= 768
                        ? "col-lg-5 d-lg-flex"
                        : "col-lg-5 mt-5"
                    }
                  >
                    <div className="col-lg-8">
                      <h5>Top Chabot Interaction</h5>
                      <div className="p-3">
                        {dataChatbotTop && (
                          <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                              <Pie
                                data={dataChatbotTop}
                                cx="50%"
                                cy="50%"
                                outerRadius={100}
                                fill="#8884d8"
                                dataKey="message_count"
                                nameKey="osa_name"
                                // label={renderLabel}
                              >
                                {dataChatbotTop.map((entry, index) => (
                                  <Cell
                                    key={`cell-${index}`}
                                    fill={colors[index % colors.length]}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        )}
                      </div>
                    </div>
                    {/* List Sukses, Invalid, Gagal di sebelah kanan dengan responsive height */}
                    <div className="col-lg-4 d-flex flex-column justify-content-between">
                      {dataChatbotTop?.map((data, index) => (
                        <div className="border rounded-3 border-soft-grey p-2 mb-2 d-flex flex-column justify-content-center h-100">
                          <div className="d-flex">
                            <div className="me-2">
                              <div
                                className="mb-1"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  backgroundColor:
                                    colors[index % colors.length],
                                  borderRadius: "50%",
                                }}
                              ></div>
                            </div>
                            <div>
                              <h5 className="mb-1">{data.osa_name}</h5>
                              <p className="text-dark fs-11 mb-0">
                                {format_number(data.message_count)} chat
                                interaction
                              </p>
                              <p className="text-dark fs-11 mb-0">
                                {format_number(data.session_count)} chat session
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
